
import React, { PureComponent } from 'react'
import { Field } from 'redux-form'
import { Button, Modal, Row } from 'react-bootstrap'
import InputMoney from '../../../../components/commons/form/InputMoney'
import InputSelect from '../../../../components/commons/form/InputSelect'
import { ivaTypeCodes } from '../../../../constants/dossier/common/taxes'

class EconomicPlanAmountWithTAXModal extends PureComponent {
  constructor (props) {
    super()
    this.state = {
      taxquantity: 0,
      amountWithoutTax: 0,
      amountWithTax: 0,
      originPristine: true
    }
  }

  getSnapshotBeforeUpdate (prevProps) {
    if (!prevProps.showModal && this.props.showModal) {
      let pristineBeforeOpen = this.props.pristine
      let valueSearch
      this.props.actions.fetchAmountTaxModal(prevProps.valueCombo || this.props.valueCombo, null, this.props.pristine, this.props.dossierType)
      this.props.ivaTypeCombo.filter((value, indx) => {
        if ((this.props.valueCombo || prevProps.valueCombo) === value.id) {
          const ivaPercentage = this.props.ivaPercentage ?? prevProps.ivaPercentage
          valueSearch = (value.code === ivaTypeCodes.OTHERS_SVO ? (ivaPercentage / 100) : value.amountValue) + 1
        }
      })
      this.setState({ taxquantity: valueSearch, originPristine: pristineBeforeOpen })
    }
    return this.props
  }

  componentDidUpdate () {
  }

  handleBlurAmount (value) {
    let amountWithoutTax = (value / this.state.taxquantity).toFixed(2)
    this.props.actions.fetchAmountTaxModal(null, amountWithoutTax, this.state.originPristine, this.props.dossierType)
    this.setState({ amountWithoutTax: amountWithoutTax, amountWithTax: value })
  }

  saveWithoutTax () {
    this.props.actions.change('dossierEconomicComponent.modelPriceAmount', this.state.amountWithoutTax)
    this.props.actions.closeModal()
  }

  closeModalWithPristine () {
    this.props.actions.fetchAmountTaxModal(0, 0, this.state.originPristine, this.props.dossierType)
    this.props.actions.closeModal()
  }

  render () {
    const { t, showModal, ivaTypeCombo } = this.props
    const tKey = 'DOSSIER_COMPONENTS.ECONOMIC_PLAN.MODAL_TAXES.'
    return (
      <Modal className='_nf EconomicPlanAmountWithTAXModal' show={showModal} onHide={() => { this.closeModalWithPristine() }}>
        <Modal.Header closeButton>
          <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className='fieldsContainer'>
            <Field
              component={InputMoney}
              colWidth={50} // 25, 33, 50, 75, 100 default=25
              id="amountWithTax"
              name="amountTaxModal.amountWithTax"
              controlLabel={t(`${tKey}AMOUNT_WITH_TAX`)}
              placeholder={t(`${tKey}AMOUNT_WITH_TAX`)}
              onInputBlur={(value) => this.handleBlurAmount(value)}
            />
            <Field
              component={InputMoney}
              colWidth={50} // 25, 33, 50, 75, 100 default=25
              id="amountWithoutTax"
              name="amountTaxModal.amountWithoutTax"
              controlLabel={t(`${tKey}AMOUNT_WITHOUT_TAX`)}
              placeholder={t(`${tKey}AMOUNT_WITHOUT_TAX`)}
            />
            <Field
              component={InputSelect}
              colWidth={50} // 25, 33, 50, 75, 100 default=25
              id="ivaType"
              name="amountTaxModal.ivaType"
              type="text"
              valueKey="id"
              labelKey="value"
              controlLabel={t(`${tKey}SELECTED_TAX`)}
              placeholder={t(`${tKey}SELECTED_TAX`)}
              options={ivaTypeCombo}
              disabled={true}
            />
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <div className="flexInLine al-C">
            <Button id="btn_save" className="_Btn accept" onClick={() => { this.saveWithoutTax() }} >{t(`${tKey}SAVE_BTN`)}</Button>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default (EconomicPlanAmountWithTAXModal)
